import type { PricingModel, TournamentType } from "@/libs/tournamentApi"

export const normalizeTournamentType = (value: string): TournamentType =>
  value === "team" ? "team" : "individual"

export const normalizePricingModel = (value: string): PricingModel =>
  value === "tiered_volume" ? "tiered_volume" : "per_event"
